/** Where an AI assist dialog runs; each source has its own quick actions and texts in `AI_ASSIST_SOURCES`. */
export enum EAiAssistSource {
  itemModal = 'itemModal',
  whiteboard = 'whiteboard',
  ishikawa = 'ishikawa',
  /** The item modal's report mode, next to `itemModal` (edit) in the same dialog. */
  itemReport = 'itemReport',
}

/** `ai_quick_actions.assistant_type` on the API: one value per AI endpoint, because each answers in its own shape. */
export enum EAiAssistantType {
  itemAssist = 'itemAssist',
  itemReport = 'itemReport',
  whiteboard = 'whiteboard',
  ishikawa = 'ishikawa',
}

/**
 * Quick actions come from the database, so a tenant may have more than these; only the ones the dialog has to reason
 * about (see `AI_ASSIST_ACTIONS_REQUIRING_DESCRIPTION`) are named here.
 */
export enum EItemAiAction {
  elaborate = 'elaborate',
  fixDescription = 'fixDescription',
  suggestTitle = 'suggestTitle',
  shorten = 'shorten',
}

/**
 * How much of the item the AI agent gets (API `EAiContextLevel`); each level adds to the one before, so a smaller one
 * uses fewer tokens: basic = title and description, standard = + type, category, status, priority, dates,
 * full = + history, comments, Ishikawa causes, linked and similar items.
 */
export enum EAiContextLevel {
  basic = 'basic',
  standard = 'standard',
  full = 'full',
}

/** `GET ai-quick-actions`; the agent's prompt stays on the API. */
export interface IAiQuickActionResponse {
  assistantType: EAiAssistantType;
  key: string;
  name: string;
  /** { "tr": "Başlık öner", … } — the viewer's language wins; `name` is the fallback. */
  nameTranslates: Record<string, string> | null;
  icon: string;
  isDefault: boolean;
}

export interface IAiAssistQuickAction {
  /** The action key, sent to the API as `action`. */
  key: string;
  icon: string;
  /** Already in the viewer's language: the template must not translate it. */
  label: string;
  isDefault: boolean;
}

export type TAiAssistQuickActionView = IAiAssistQuickAction & { isDisabled: boolean };

/** The texts that differ between the dialogs sharing the request form. */
export interface IAiAssistSourceConfig {
  subtitleKey: string;
  promptPlaceholderKey: string;
  loadingKey: string;
  previewSubtitleKey: string;
}

/** What the request form hands to its dialog on Generate; `action` is a key of the source's quick actions. */
export interface IAiAssistGenerateRequest {
  action: string | null;
  prompt: string | null;
  contextLevel: EAiContextLevel;
}
